import React from 'react';
import { Route, Redirect } from 'react-router-dom';

export const PrivateRoute = ({ children, loggedIn, ...rest }) => (
    <Route {...rest} render={props => {
        if (!loggedIn) {
            // not logged in so redirect to login page with the return url
            return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
        }

        // authorised so return component
        return children 
    }} />
)

export default PrivateRoute;